import { Toaster as SonnerToaster } from 'sonner'
import type { ToasterProps } from 'sonner'

interface ToasterCustomProps extends Omit<ToasterProps, 'toastOptions'> {}

export function Toaster(props: ToasterCustomProps = {}) {
  return (
    <SonnerToaster
      position="top-center"
      richColors
      closeButton
      expand
      visibleToasts={4}
      duration={4000}
      offset={16}
      gap={8}
      toastOptions={{
        classNames: {
          toast:
            'rounded-md shadow-popover border px-3.5 py-2.5 gap-2.5 items-start',
          title: 'text-sm font-medium',
          description: 'text-xs text-gray-500',
          actionButton:
            'h-7 rounded-md bg-primary px-2.5 text-xs font-medium text-white hover:bg-primary/90',
          cancelButton:
            'h-7 rounded-md bg-gray-100 px-2.5 text-xs font-medium text-gray-500 hover:bg-gray-200',
          closeButton:
            'border-gray-200 bg-white text-gray-500 hover:bg-gray-50',
          success: 'bg-green-50 border-green-500 text-gray-900',
          error: 'bg-red-50 border-red-500 text-gray-900',
          warning: 'bg-orange-100 border-orange-500 text-gray-900',
          info: 'bg-blue-50 border-primary text-gray-900',
        },
      }}
      {...props}
    />
  )
}
